












































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mdiEmailOutline, mdiEmailOpenOutline, mdiChevronRight, mdiChevronLeft } from '@mdi/js'

import { DataOptions } from 'vuetify'

import type { BreadcrumbsItem } from '@/components/lib/Breadcrumbs.vue'

import { notifications } from '@/store/modules/notifications'
import Breadcrumbs from '@/components/lib/Breadcrumbs.vue'
import { Notification } from '@/api'
import { mock } from '@/tools'

@Component({
  components: {
    Breadcrumbs,
  },
})
class NotificationsView extends Vue {
  notificationsModule = notifications.context(this.$store)

  icons = {
    mdiEmailOutline,
    mdiEmailOpenOutline,
    mdiChevronRight,
    mdiChevronLeft,
  }

  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Главная',
      disabled: false,
      to: { name: 'main' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]

  get notificationsOptions() {
    return this.notificationsModule.state.tableOptions
  }

  set notificationsOptions(options: DataOptions) {
    this.notificationsModule.mutations.setTableOptions(options)
  }

  getTypedItems(items: unknown) {
    return items as Array<Notification>
  }

  @Watch('notificationsOptions', { deep: true })
  async getNotifications() {
    await this.notificationsModule.actions.getTableItems().catch(mock)
  }
}

export default NotificationsView
